export type Palette = {
  text: string;
  mutedText: string;
  inputBackground: string;
  inputFocusBackground: string;
  surface: string;
  border: string;
  error: string;
};

/** The colour of `--colour-liability-red`, which both palettes share. */
const ERROR = 'rgb(236 52 37)';

export const PALETTE: Record<'light' | 'dark', Palette> = {
  light: {
    text: 'rgb(13 13 13)',
    mutedText: 'rgb(155 155 155)',
    inputBackground: 'rgb(230 230 230)',
    inputFocusBackground: 'rgb(255 255 255)',
    surface: 'rgb(244 244 244)',
    border: 'rgb(206 206 206)',
    error: ERROR,
  },
  dark: {
    text: 'rgb(255 255 255)',
    mutedText: 'rgb(80 80 80)',
    inputBackground: 'rgb(38 38 38)',
    inputFocusBackground: 'rgb(13 13 13)',
    surface: 'rgb(28 28 28)',
    border: 'rgb(54 54 54)',
    error: ERROR,
  },
};
